import { AfterContentInit, Directive, Input } from "@angular/core";

@Directive({
  selector: "[patchPCalendarIcon]",
  standalone: false,
})
export class BfxPatchPCalendarIcon implements AfterContentInit {
  @Input("patchPCalendarIcon")
  public component: any | null = null;

  public ngAfterContentInit(): void {
    this.component.icon = "fa icon-calendar_month";
  }
}
